import { gql } from '@/__generated__';

const GET_USER_PREFERENCES_INTERFACE = gql(`#graphql
  query GetUserPreferencesInterface($input: UserInput) {
    user(input: $input) {
      id
      preferences {
        id
        interface {
          id
          defaultIndexRoute
        }
        defaultInterface: interface(defaultValues: true) {
          defaultIndexRoute
        }
      }
    }
  }
`);

export default GET_USER_PREFERENCES_INTERFACE;
